/* Cocooning Baby - panier : ajout cross-sell (1/Duo/Trio) en AJAX + refresh drawer.
   Ecoute en CAPTURE sur document : passe AVANT les listeners du drawer qui stoppent
   la propagation, donc le clic est toujours capte meme apres re-render. */
(function () {
  if (window._cbCartInit) return;
  window._cbCartInit = true;

  function handle(e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-cbups-add]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.dataset.cbBusy === '1') return;
    var id = parseInt(btn.getAttribute('data-cbups-add'), 10);
    if (!id) return;
    btn.dataset.cbBusy = '1';
    btn.classList.add('is-loading');

    var cd = document.querySelector('cart-drawer');
    var sections = cd && cd.getSectionsToRender
      ? cd.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer'];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { // erreur Shopify (ex: 422)
          btn.dataset.cbBusy = '0'; btn.classList.remove('is-loading');
          return;
        }
        if (cd && typeof cd.renderContents === 'function') {
          cd.classList.remove('is-empty');
          cd.renderContents(res);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () { btn.dataset.cbBusy = '0'; btn.classList.remove('is-loading'); });
  }

  // capture = true : prioritaire sur les stopPropagation internes du drawer
  document.addEventListener('click', handle, true);
})();
